import Component from "@tunnel-components/@pages/supervision/systems/config/component";
import * as React from "react";
import {
  sectionsettingsactioncreator,
  sectionzonesloadedresetactioncreator,
  setsectionsettingsresetactioncreator,
  sectionzonesloadedactioncreator,
  getallzoneformaskloadedactioncreator,
  sectionsavezoneactioncreator,
} from "@tunnel-store/index";
import { connect } from "react-redux";
import * as Lodash from "lodash";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name onChange
 * @name onDisabled
 * @name onSubmit
 * @name onUpdateSectionZone
 * @name onUpdateSectionSettings
 * @name
 * @name componentDidUpdate
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */

class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }       state
     * @property { boolean }      state.errorserver
     * @property { boolean }      state.loading
     * ......
     */
    this.state = {
      // IdentifiantSection: props.match.params.section,
      bau: false,
      bauChecked: true,
      bauMileageEnd: "",
      bauMileageStart: "",
      color: "",
      disabled: true,
      errorserver: false,
      identifiantsection: props.match.params.section,
      length: "",
      loading: false,
      mileageEnd: "",
      mileageStart: "",
      name: "",
      parking: false,
      parkingChecked: true,
      parkingMileageEnd: "",
      parkingMileageStart: "",
      quickroad: false,
      quickroadChecked: true,
      quickroadMileageEnd: "",
      quickroadMileageStart: "",
      slowroad: false,
      slowroadChecked: true,
      slowroadMileageEnd: "",
      slowroadMileageStart: "",
      sw: false,
      swChecked: true,
      swMileageEnd: "",
      swMileageStart: "",
      type: "",
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onChange = this.onChange.bind(this);
    this.onDisabled = this.onDisabled.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  /**
   * manipulation des input
   * @method onChange
   * @param { any  }  event
   * @infos "https://reactjs.org"
   */
  public onChange = (event: any): void => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState({
      [event.target.name]: event.target.value,
    });
    {
      /** Comparaison */
    }
    if (
      event.target.name === "bauMileageEnd" &&
      parseInt(this.state.bauMileageStart, 10) ===
        parseInt(event.target.value, 10)
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        bauChecked: false,
      }));
    } else if (
      event.target.name === "bauMileageEnd" &&
      parseInt(this.state.bauMileageStart, 10) !==
        parseInt(event.target.value, 10)
    ) {
      this.setState((state: any): any => ({
        bauChecked: true,
      }));
    }
    {
      /** Comparaison */
    }
    if (
      event.target.name === "bauMileageStart" &&
      parseInt(this.state.bauMileageEnd, 10) ===
        parseInt(event.target.value, 10)
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        bauChecked: false,
      }));
    } else if (
      event.target.name === "bauMileageStart" &&
      parseInt(this.state.bauMileageEnd, 10) !==
        parseInt(event.target.value, 10)
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        bauChecked: true,
      }));
    }
    {
      /** Comparaison */
    }
    if (
      event.target.name === "parkingMileageEnd" &&
      parseInt(this.state.parkingMileageStart, 10) ===
        parseInt(event.target.value, 10)
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        parkingChecked: false,
      }));
    } else if (
      event.target.name === "parkingMileageEnd" &&
      parseInt(this.state.parkingMileageStart, 10) !==
        parseInt(event.target.value, 10)
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        parkingChecked: true,
      }));
    }
    {
      /** Comparaison */
    }
    if (
      event.target.name === "parkingMileageStart" &&
      parseInt(this.state.parkingMileageStart, 10) ===
        parseInt(event.target.value, 10)
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        parkingChecked: false,
      }));
    } else if (
      event.target.name === "parkingMileageStart" &&
      parseInt(this.state.parkingMileageStart, 10) !==
        parseInt(event.target.value, 10)
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        parkingChecked: true,
      }));
    }
    {
      /** Comparaison */
    }
    if (
      event.target.name === "quickroadMileageEnd" &&
      parseInt(this.state.quickroadMileageStart, 10) ===
        parseInt(event.target.value, 10)
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        quickroadChecked: false,
      }));
    } else if (
      event.target.name === "quickroadMileageEnd" &&
      parseInt(this.state.quickroadMileageStart, 10) !==
        parseInt(event.target.value, 10)
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        quickroadChecked: true,
      }));
    }
    {
      /** Comparaison */
    }
    if (
      event.target.name === "quickroadMileageStart" &&
      parseInt(this.state.quickroadMileageEnd, 10) ===
        parseInt(event.target.value, 10)
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        quickroadChecked: false,
      }));
    } else if (
      event.target.name === "quickroadMileageStart" &&
      parseInt(this.state.quickroadMileageEnd, 10) !==
        parseInt(event.target.value, 10)
    ) {
      this.setState((state: any): any => ({
        quickroadChecked: true,
      }));
    }
    {
      /** Comparaison */
    }
    if (
      event.target.name === "slowroadMileageEnd" &&
      parseInt(this.state.slowroadMileageStart, 10) ===
        parseInt(event.target.value, 10)
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        slowroadChecked: false,
      }));
    } else if (
      event.target.name === "slowroadMileageEnd" &&
      parseInt(this.state.slowroadMileageStart, 10) !==
        parseInt(event.target.value, 10)
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        slowroadChecked: true,
      }));
    }
    {
      /** Comparaison */
    }
    if (
      event.target.name === "slowroadMileageStart" &&
      parseInt(this.state.slowroadMileageEnd, 10) ===
        parseInt(event.target.value, 10)
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState({
        slowroadChecked: false,
      });
    } else if (
      event.target.name === "slowroadMileageStart" &&
      parseInt(this.state.slowroadMileageEnd, 10) !==
        parseInt(event.target.value, 10)
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        slowroadChecked: true,
      }));
    }
    {
      /** Comparaison */
    }
    if (
      event.target.name === "swMileageEnd" &&
      parseInt(this.state.swMileageStart, 10) ===
        parseInt(event.target.value, 10)
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        swChecked: false,
      }));
    } else if (
      event.target.name === "swMileageEnd" &&
      parseInt(this.state.swMileageStart, 10) !==
        parseInt(event.target.value, 10)
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        swChecked: true,
      }));
    }
    {
      /** Comparaison */
    }
    if (
      event.target.name === "swMileageStart" &&
      parseInt(this.state.swMileageEnd, 10) === parseInt(event.target.value, 10)
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        swChecked: false,
      }));
    } else if (
      event.target.name === "swMileageStart" &&
      parseInt(this.state.swMileageEnd, 10) !== parseInt(event.target.value, 10)
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        swChecked: true,
      }));
    }
  };

  /**
   * @method onDisabled
   * @param { any  }  event
   * @infos "https://reactjs.org"
   */
  public onDisabled = (event: any): void => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      disabled: !this.state.disabled,
    }));
  };

  /**
   * MAJ des data
   * @method onSubmit
   * @param { any }  event
   * @infos "https://reactjs.org"
   */
  public onSubmit = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState({
      btnloading: true,
    });
    {
      /** vérification de l'existence de l'élement  */
    }
    if (
      this.state.bauChecked &&
      this.state.parkingChecked &&
      this.state.slowroadChecked &&
      this.state.quickroadChecked &&
      this.state.swChecked
    ) {
      this.props
        .getallzoneformaskloadedactioncreator()
        .then(() => {
          {
            /** vérification de l'existence de l'élement  */
          }
          if (this.props.zones && Lodash.isEmpty(this.props.zones)) {
            this.props.zones.map((zoneref: any) => {
              const label = zoneref.label.toLowerCase();
              const mileageStart = label + "MileageStart";
              const mileageEnd = label + "MileageEnd";
              if (this.state[label]) {
                const direction = {
                  id: {
                    sectionId: this.props.match.params.section,
                    zoneId: zoneref.id,
                  },
                  mileageEnd: this.state[mileageEnd],
                  mileageStart: this.state[mileageStart],
                };
                this.props
                  .sectionsavezoneactioncreator(direction)
                  .then(() =>
                    this.setState((state: any): any => ({ btnloading: false }))
                  );
              }
            });
          }
        })
        .then(() =>
          this.setState((state: any): any => ({ btnloading: false }))
        );
    }

    this.onDisabled(event);
  };

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** Comparaison */
    }
    if (nextProps.error !== this.props.error) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.error)) {
        this.setState((state: any): any => ({ errorserver: true }));
      }
      {
        /** Comparaison */
      }
    } else if (nextProps.sectionsettings !== this.props.sectionsettings) {
      this.onUpdateSectionSettings(nextProps.sectionsettings);
    } else if (nextProps.zones !== this.props.zones) {
      this.onUpdateSectionZone(nextProps.sectionzones, nextProps.zones);
    }
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    {
      /** Comparaison */
    }
    if (prevState.identifiantsection !== this.state.identifiantsection) {
      {
        /** Comparaison */
      }
      if (prevProps.sectionzones !== this.props.sectionzones) {
        {
          /** Comparaison */
        }
        if (prevProps.zones !== this.props.zones) {
          this.onUpdateSectionZone(this.props.sectionzones, this.props.zones);
        }
      }
    }
  }
  /**
   * MAJ des paramètres de la section
   * @public
   * @method onUpdateSectionSettings
   * @param { any } Elem
   * @infos "https://reactjs.org"
   */
  public onUpdateSectionSettings(Elem: any) {
    {
      /** vérification de l'existence de l'élement  */
    }
    if (typeof Elem === "object") {
      this.setState((state: any): any => ({
        color: Elem.colorRgbString,
        length: Math.abs(Number(Elem.mileageStart) - Number(Elem.mileageEnd)),
        mileageEnd: Elem.mileageEnd,
        mileageStart: Elem.mileageStart,
        name: Elem.name,
        type: Elem.sectionTypeName,
      }));
    }
  }
  /**
   * MAJ des zones
   * @public
   * @method onUpdateSectionZone
   * @param { any } Zones
   * @param { any } SectionZones
   * @infos "https://reactjs.org"
   */
  public onUpdateSectionZone = (SectionZones: any, Zones: any): void => {
    {
      /** vérification de l'existence de l'élement  */
    }
    if (Lodash.isArray(SectionZones)) {
      SectionZones.map((zone: any) => {
        {
          /** vérification de l'existence de l'élement  */
        }
        if (Lodash.isArray(Zones)) {
          Promise.all(
            Zones.map((zoneref: any) => {
              {
                /** comparaison */
              }
              if (zoneref.id === zone.zoneId) {
                const name = zoneref.label.toLowerCase();
                const mileageStart = name + "MileageStart";
                const mileageEnd = name + "MileageEnd";
                if (name === "road") {
                  {
                    /** Empêcher la mutation du state */
                  }
                  this.setState((state: any): any => ({
                    quickroad: true,
                    quickroadMileageEnd: zone.mileageEnd,
                    quickroadMileageStart: zone.mileageStart,
                    slowroad: true,
                    slowroadMileageEnd: zone.mileageEnd,
                    slowroadMileageStart: zone.mileageStart,
                  }));
                } else {
                  {
                    /** Empêcher la mutation du state */
                  }
                  this.setState({
                    [mileageEnd]: zone.mileageEnd,
                    [mileageStart]: zone.mileageStart,
                    [name]: true,
                  });
                }
              }
            })
          );
        }
      });
    }
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ loading: true });

    this.props
      .sectionsettingsactioncreator(this.props.match.params.section)
      .then(() => {
        this.onUpdateSectionSettings(this.props.sectionsettings);
      });

    this.props
      .sectionzonesloadedactioncreator(this.props.match.params.section)
      .then(() => {
        this.props.getallzoneformaskloadedactioncreator().then(() => {
          this.onUpdateSectionZone(this.props.sectionzones, this.props.zones);
        });
      })
      .then(() => this.setState({ loading: false }))
      .then(() => {
        if (!Lodash.isUndefined(this.props.error)) {
          this.setState({ errorserver: true });
        }
      });
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState({
      errorserver: false,
      loading: false,
    });

    this.props.setsectionsettingsresetactioncreator();
    this.props.sectionzonesloadedresetactioncreator();
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        onChange={this.onChange}
        onSubmit={this.onSubmit}
        {...this.state}
        {...this.props}
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    error: state.SectionZonesLoaded.error,
    sectionsettings: state.SectionSettings.data,
    sectionzones: state.SectionZonesLoaded.data,
    zones: state.GetAllZoneForMaskLoaded.data,
  };
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, {
  sectionzonesloadedresetactioncreator,
  setsectionsettingsresetactioncreator,
  sectionsettingsactioncreator,
  sectionzonesloadedactioncreator,
  getallzoneformaskloadedactioncreator,
  sectionsavezoneactioncreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/systems/config/container.tsx